import { faChevronDown } from "@jewlr/pro-solid-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-solid-svg-icons/faChevronUp"
import { useHandleOutsideClick } from "@jewlr/storybook/helpers"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { useState, useRef } from "react"

import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import useNavigation from "helpers/use-navigation"
import withCountrySwitch from "hoc/with-country-switch"
import getCountries from "site-data/portal/countries"

const CountryOption = ({ closeDropdown, country, index, onClick }) => {
  const keyboardProps = useNavigation({ onEscape: closeDropdown })

  return (
    <Button
      aria-selected="false"
      className="flex w-full focus:outline focus:outline-offset-1 focus:outline-white"
      onClick={onClick}
      role="option"
      tabIndex={index === 0 ? "0" : "-1"}
      {...keyboardProps}
    >
      <Image
        alt=""
        className="mr-8"
        height="16"
        src={require(
          `images/layout/header/country/${country.site_country}.svg`
        )}
        width="25"
      />
      <span className="text-14 tracking-half leading-16 w-full text-left font-medium text-white">
        {country.human_country}
      </span>
    </Button>
  )
}

CountryOption.propTypes = {
  closeDropdown: PropTypes.func,
  country: PropTypes.object,
  index: PropTypes.number,
  onClick: PropTypes.func,
}

const CountrySelector = ({ doSwitch }) => {
  const countries = getCountries()
  const countrySelectorRef = useRef()
  const [expanded, showOptions] = useState(false)

  const currentCountry = countries.find(
    ({ geo }) => geo === sl.config.site_country_for_analytics
  )
  useHandleOutsideClick({
    enabled: expanded,
    onOutsideClick: () => showOptions(false),
    ref: countrySelectorRef,
  })

  return (
    <div
      aria-label="Change Country"
      className="relative"
      ref={countrySelectorRef}
    >
      <Button
        aria-expanded={expanded}
        aria-haspopup="listbox"
        className="bg-primary h-28 w-full px-8 focus-visible:outline-white"
        id="country-selector-button"
        onClick={() => showOptions(!expanded)}
      >
        <div className="flex items-center">
          <Image
            alt=""
            className="mr-8"
            height="16"
            src={require(
              `images/layout/header/country/${currentCountry.site_country}.svg`
            )}
            width="25"
          />
          <span className="text-14 tracking-half leading-16 w-full text-left font-medium text-white">
            {currentCountry.human_country}
          </span>
        </div>
        <FontAwesomeIcon
          className="text-8 ml-4 text-white"
          icon={expanded ? faChevronUp : faChevronDown}
        />
      </Button>
      {expanded && (
        <>
          <FocusScope contain restoreFocus>
            <div
              aria-labelledby="country-selector-button"
              className="bg-primary tablet:absolute z-50 w-full p-8"
              id="country-selector-list"
              role="listbox"
            >
              {countries
                .filter(
                  ({ geo }) => geo !== sl.config.site_country_for_analytics
                )
                .map((country, index) => (
                  <CountryOption
                    closeDropdown={() => showOptions(false)}
                    country={country}
                    index={index}
                    key={country.geo}
                    onClick={() => doSwitch(country.geo)}
                  />
                ))}
            </div>
          </FocusScope>
        </>
      )}
    </div>
  )
}

CountrySelector.propTypes = {
  doSwitch: PropTypes.func,
}

export default withCountrySwitch(CountrySelector)
